ped_info_handler = {

    properties: {
    },

    onLoad: function(){
        var self = this;

        $('#content-root, #map').removeClass('swipe');
        $('#content-root').addClass('large white-bg');

    },


    events: function() {
        var self = this;
        self.onLoad();

        $('.content-close-btn').click(function(event) {
            window.location.href = "#/" + properties.previousURL;
            return false;
        });

        $('.bike-rendering-popup').click(function(event) {

            $("#rendering-info").modal({
                clickClose: true
            });

            return false;
        });

    }
}